import { compose, setDisplayName } from 'recompose';
import requireUser from '../../services/HOC/requireUser';
import requireGuest from '../../services/HOC/requireGuest';

export default compose(
  setDisplayName('pageHome'),
  requireUser,
  requireGuest
)(() => null);
